/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ProviderListModel } from '../models/provider-list-model';
import { ProviderListResult } from '../models/provider-list-result';
import { ProviderToggleModel } from '../models/provider-toggle-model';
import { ProviderToggleResult } from '../models/provider-toggle-result';

@Injectable({
  providedIn: 'root',
})
export class AccountProviderService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation v1ProviderListPost
   */
  static readonly V1ProviderListPostPath = '/v1/provider/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1ProviderListPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ProviderListPost$Plain$Response(params?: {
    body?: ProviderListModel
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProviderListResult>> {

    const rb = new RequestBuilder(this.rootUrl, AccountProviderService.V1ProviderListPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProviderListResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1ProviderListPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ProviderListPost$Plain(params?: {
    body?: ProviderListModel
  },
  context?: HttpContext

): Observable<ProviderListResult> {

    return this.v1ProviderListPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProviderListResult>) => r.body as ProviderListResult)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1ProviderListPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ProviderListPost$Json$Response(params?: {
    body?: ProviderListModel
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProviderListResult>> {

    const rb = new RequestBuilder(this.rootUrl, AccountProviderService.V1ProviderListPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProviderListResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1ProviderListPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ProviderListPost$Json(params?: {
    body?: ProviderListModel
  },
  context?: HttpContext

): Observable<ProviderListResult> {

    return this.v1ProviderListPost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProviderListResult>) => r.body as ProviderListResult)
    );
  }

  /**
   * Path part for operation v1ProviderTogglePost
   */
  static readonly V1ProviderTogglePostPath = '/v1/provider/toggle';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1ProviderTogglePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ProviderTogglePost$Plain$Response(params?: {
    body?: ProviderToggleModel
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProviderToggleResult>> {

    const rb = new RequestBuilder(this.rootUrl, AccountProviderService.V1ProviderTogglePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProviderToggleResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1ProviderTogglePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ProviderTogglePost$Plain(params?: {
    body?: ProviderToggleModel
  },
  context?: HttpContext

): Observable<ProviderToggleResult> {

    return this.v1ProviderTogglePost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProviderToggleResult>) => r.body as ProviderToggleResult)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1ProviderTogglePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ProviderTogglePost$Json$Response(params?: {
    body?: ProviderToggleModel
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProviderToggleResult>> {

    const rb = new RequestBuilder(this.rootUrl, AccountProviderService.V1ProviderTogglePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProviderToggleResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1ProviderTogglePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1ProviderTogglePost$Json(params?: {
    body?: ProviderToggleModel
  },
  context?: HttpContext

): Observable<ProviderToggleResult> {

    return this.v1ProviderTogglePost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProviderToggleResult>) => r.body as ProviderToggleResult)
    );
  }

}
